import React, {ReactNode, useRef} from 'react';
import {Button} from '~/components/Button';
import {Menu} from '~/components/Menu';
import {Intent} from '~/lib/intent';
import {Schema} from '~/modules/Bidders/models/Schema';
import {IAttributeInfo} from '../../models/Rule';

interface IAttributesMenuProps {
    schema: Schema;
    onSelect: (attrivuteInfo: IAttributeInfo) => void;
    children?: ReactNode;
}

export const AttributesMenu = ({schema, onSelect, children}: IAttributesMenuProps) => {
    const buttonRef = useRef();

    return <>
        <Button ref={buttonRef} leftIcon={<i className='fa fa-plus'/>} intent={Intent.PRIMARY} responsive children={children}/>
        <Menu items={schema.attributes().map(attributeInfo => ({
            children: attributeInfo.label,
            onClick: () => onSelect(attributeInfo)
        }))} parentRef={buttonRef}/>
    </>;
};
